<template>
  <el-dialog title="添加物业公司" :visible="visible" width="40%" @close="handleClose">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px" class="text-left">
      <el-form-item label="公司名称" prop="name">
        <el-input v-model="formData.name" placeholder="请输入公司名称" />
      </el-form-item>
      <el-form-item label="公司地址" prop="address">
        <el-input v-model="formData.address" placeholder="请输入公司地址" />
      </el-form-item>
      <el-form-item label="联系电话" prop="tel">
        <el-input v-model="formData.tel" placeholder="请输入联系电话" />
      </el-form-item>
      <el-form-item label="法人代表" prop="corporation">
        <el-input v-model="formData.corporation" placeholder="请输入法人代表" />
      </el-form-item>
      <el-form-item label="成立时间" prop="foundingTime">
        <el-date-picker
          v-model="formData.foundingTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择成立时间"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="附近地标" prop="nearbyLandmarks">
        <el-input v-model="formData.nearbyLandmarks" placeholder="请输入附近地标" />
      </el-form-item>
      <el-form-item label="关联小区">
        <el-select
          v-model="formData.communityIds"
          multiple
          filterable
          style="width: 100%"
          placeholder="请选择关联小区"
        >
          <el-option
            v-for="item in communities"
            :key="item.communityId"
            :label="item.name"
            :value="item.communityId"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="formData.communityIds && formData.communityIds.length > 0"
        label="功能权限"
      >
        <el-checkbox v-model="formData.isAll" @change="handleCheckAll">全选</el-checkbox>
        <el-checkbox-group v-model="formData.groupIds" @change="handleCheckGroup">
          <el-checkbox v-for="group in menuGroups" :key="group.gId" :label="group.gId">
            {{ group.name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveProperty, listMenuGroup, listNoEnterCommunity } from '@/api/store/propertyCompanyManageApi'
	import {
		listCommunitys
	} from "@/api/community/propertyCommunityApi";
export default {
  name: 'AddPropertyCompany',
  data() {
    return {
      visible: false,
      formData: {
        name: '',
        address: '',
        tel: '',
        corporation: '',
        foundingTime: '',
        nearbyLandmarks: '',
        communityIds: [],
        groupIds: [],
        isAll: true
      },
      communities: [],
      menuGroups: [],
      rules: {
        name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        address: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
        tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        corporation: [{ required: true, message: '请输入法人代表', trigger: 'blur' }],
        foundingTime: [{ required: true, message: '请选择成立时间', trigger: 'change' }],
        nearbyLandmarks: [{ required: true, message: '请输入附近地标', trigger: 'blur' }]
      },
	  searchForm: {
	  	communityId: "",
	  	name: "",
	  	memberId: "",
	  },
	  page: {
	  	current: 1,
	  	size: 100000000,
	  	total: 0,
	  }
    }
  },
  methods: {
    open() {
      this.visible = true
      this.fetchMenuGroups()
      this.fetchCommunities()
    },
    async fetchMenuGroups() {
      try {
        const { data } = await listMenuGroup({ page: 1, row: 100, storeType: '800900000003' })
        this.menuGroups = data
        this.formData.groupIds = data.map(item => item.gId)
      } catch (error) {
        this.$message.error('获取菜单组失败')
      }
    },
    async fetchCommunities() {
      try {
        // const res = await listNoEnterCommunity({ communityName: '' })
        // const list = res.data|| []
        // this.communities = list.filter(item => item.name !== '待认证')
		const params = {
				page: this.page.current,
				row: this.page.size,
				...this.searchForm,
			};
			const {
				data,
				total
			} = await listCommunitys(params);
			this.communities = data.filter(item => item.name !== "待审核"&&(item.storeId == undefined || item.storeId == null || item.storeId == '')) || [];
      } catch (error) {
        this.$message.error('获取小区列表失败')
      }
    },
    handleCheckAll(val) {
      this.formData.groupIds = val ? this.menuGroups.map(item => item.gId) : []
    },
    handleCheckGroup() {
      this.formData.isAll = this.formData.groupIds.length === this.menuGroups.length
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        await saveProperty(this.formData)
        this.$message.success('添加成功')
        this.$emit('success')
        this.handleClose()
      } catch (error) {
        if (error) this.$message.error(error.message || '添加失败')
      }
    },
    handleClose() {
      this.visible = false
      this.$refs.form && this.$refs.form.resetFields()
      this.formData = {
        name: '',
        address: '',
        tel: '',
        corporation: '',
        foundingTime: '',
        nearbyLandmarks: '',
        communityIds: [],
        groupIds: [],
        isAll: true
      }
    }
  }
}
</script>
